export enum PaymentStatus {
  Paid = 'PAID',
  Refunded = 'REFUNDED',
  Pending = 'PENDING',
  Failed = 'FAILED',
  Annulled = 'ANNULLED'
}
